/** The admin console's sections, in sidebar order; each is `/admin?tab=<value>`. */
export const ADMIN_SECTIONS = [
	{ value: 'accounts', label: 'Accounts' },
	{ value: 'support', label: 'Support' },
	{ value: 'crashes', label: 'Crashes and Errors' },
	{ value: 'users', label: 'Users & invites' },
	{ value: 'watchlist', label: 'Review watchlist' },
	{ value: 'polling', label: 'Polling' },
	{ value: 'environment', label: 'Environment' },
] as const

export type AdminSection = (typeof ADMIN_SECTIONS)[number]['value']

/** The section `/admin` shows when the URL names none (or one that doesn't exist). */
export const DEFAULT_ADMIN_SECTION: AdminSection = 'users'

export function adminSection(tab: string | null): AdminSection {
	return ADMIN_SECTIONS.find((s) => s.value === tab)?.value ?? DEFAULT_ADMIN_SECTION
}
